
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/basics/chatbox",
      function () {
        return require("private-next-pages/x/react-chat/basics/chatbox.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/basics/chatbox"])
      });
    }
  